import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="audit-layout flex h-screen overflow-hidden bg-background text-foreground" data-testid="audit-layout">
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex w-64 flex-col shrink-0 border-r border-border bg-card/60 backdrop-blur-xl">
        <Sidebar />
      </aside>

      {/* Mobile Drawer Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden flex">
          <div
            className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
            onClick={() => setMobileMenuOpen(false)}
          />
          <aside className="relative flex w-72 max-w-[85vw] flex-col bg-card border-r border-border shadow-2xl z-10">
            <Sidebar onClose={() => setMobileMenuOpen(false)} />
          </aside>
        </div>
      )}

      {/* Main Container */}
      <div className="flex flex-1 flex-col min-w-0 h-full overflow-hidden">
        {/* Top Header */}
        <header className="sticky top-0 z-30 h-16 border-b border-border/80 bg-card/70 backdrop-blur-xl">
          <Header onToggleMobileMenu={() => setMobileMenuOpen(prev => !prev)} />
        </header>

        {/* Content View */}
        <main className="audit-main flex-1 overflow-y-auto relative p-0 ambient-canvas bg-background">
          <div className="ambient-orb orb-one" />
          <div className="ambient-orb orb-two" />
          <div className="ambient-particles" />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

